import api from "@/services/api";
 
//  Paquetes de exámenes
export const paqueteService = {
  listar:     ()         => api.get("paquetes"),
  obtener:    (id)       => api.get(`paquetes/${id}`),
  crear:      (data)     => api.post("paquetes", data),
  actualizar: (id, data) => api.put(`paquetes/${id}`, data),
  eliminar:   (id)       => api.delete(`paquetes/${id}`),
};
 
//  Catálogo de exámenes (para el selector del formulario)
export const examenService = {
  listar: () => api.get("vwexamens"),
};
 
//  Pedidos
export const pedidoService = {
  registrarDesdePaquete: (data) => api.post("pedidos/desde-paquete", data),
};